// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountGetSitesDefaultResponse {
    static getAttributeTypeMap() {
        return AccountGetSitesDefaultResponse.attributeTypeMap;
    }
}
AccountGetSitesDefaultResponse.discriminator = undefined;
AccountGetSitesDefaultResponse.additionalProperties = false;
AccountGetSitesDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=accountGetSitesDefaultResponse.js.map